<template>
  <div>
    <el-button type="primary" round style="margin-bottom: 20px;" @click="pop">购买套餐</el-button>
    <span style="margin-left: 20px;" v-if="user.is_vip>0">套餐类型： {{user.is_vip==1 ? '基础版' : (user.is_vip==2 ?
        '专业版':'VIP版')
      }}</span>
    <span style="margin-left: 20px;" v-if="user.is_vip>0">到期时间： {{user.end_time}}</span>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="订单号" prop="order_no"></el-table-column>
      <el-table-column label="开通方式" prop="type"></el-table-column>
      <el-table-column label="支付金额" prop="money"></el-table-column>
      <el-table-column label="赠送次数" prop="look_num"></el-table-column>
      <el-table-column label="提交时间" prop="addtime"></el-table-column>
      <el-table-column label="支付状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pay==1">已支付</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pay==0">未支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="支付时间" prop="pay_time"></el-table-column>
      <el-table-column label="操作" width="220px">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <Layer-pop title="购买套餐" @close="vue_pop_show_hide" v-if="is_pop">
      <div>
        <template v-for="(item,key) in class_list" >
          <div class="item" v-bind:key="key">
            <div style="margin-right: 50px;text-align: center;font-size: 22px;">
              <div style="margin-bottom: 10px;">{{ item.title }}</div>
              <div style="color: #ff0000"><span style="font-size:40px;">{{ item.price }}</span>元/年</div>
            </div>
            <div >
              <div class="mb-10">书本总数量：{{ item.ebook_total }}本</div>
              <div class="mb-10">单页总数量：{{ item.page_total }}页</div>
              <div class="mb-10">赠送次数：{{ item.use_total }}</div>
              <div class="mb-10">媒体容量：{{ item.media }}M</div>
              <div>充值次数优惠{{ item.discount }}折</div>
            </div>
            <el-button style="margin-left: 120px;" type="primary" round @click="topay(key+1,item)">立即购买</el-button>
          </div>
        </template>
<!--        <div class="item">
          <div style="margin-right: 50px;text-align: center;font-size: 22px;">
            <div >基础版</div>
            <div style="color: red"><span style="font-size:40px;">388</span>元/年</div>
          </div>
          <div style="margin-right: 60px;">
            <div class="mb-10">书本总数量：10本</div>
            <div class="mb-10">赠送次数：10000</div>
            <div>充值次数优惠8折</div>
          </div>
          <el-button type="primary" round @click="topay(1,388,10000)" :disabled="ebook_num>10 ? 'disabled' : false "
          >立即购买
          </el-button>
        </div>
        <div class="item">
          <div style="margin-right: 50px;text-align: center;font-size: 22px;">
            <div style="margin-bottom: 10px;">专业版</div>
            <div style="color: #ff0000"><span style="font-size:35px;">1288</span>元/年</div>
          </div>
          <div style="margin-right: 60px;">
            <div class="mb-10">书本总数量：100本</div>
            <div class="mb-10">赠送次数：60000</div>
            <div>充值次数优惠6折</div>
          </div>
          <el-button type="primary" round @click="topay(2,1288,60000)">立即购买</el-button>
        </div>
        <div class="item">
          <div style="margin-right: 50px;text-align: center;font-size: 22px;">
            <div style="margin-bottom: 10px;">VIP版</div>
            <div style="color: #ff0000"><span style="font-size:35px;">2888</span>元/年</div>
          </div>
          <div style="margin-right: 60px;">
            <div class="mb-10">书本总数量：无限</div>
            <div class="mb-10">赠送次数：100000</div>
            <div>充值次数优惠5折</div>
          </div>
          <el-button type="primary" round @click="topay(3,2888,100000)">立即购买</el-button>
        </div>-->
      </div>
      <div class="bg" v-if="is_pay">
        <div class="box">
          <div class="mt-10">扫码支付</div>
          <img :src="pay_code" style="width: 100%;height: 100%">
          <span class="iconfont icon-close-circle" @click="pay_close"></span>
        </div>
      </div>
    </Layer-pop>
  </div>
</template>

<script>
import LayerPop from "@/components/layer-pop";

export default {
name: "vip",
  components:{LayerPop},
  data(){
  return{
    list:[],
    class_list:[],
    is_load:false,
    page:1,
    total:0,
    is_pop:false,
    select:0,
    setting:[],
    pay_no:'',
    pay_code:'',
    is_pay:false,
    ebook_num:0,
  }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    get_list: async function (){
      if(!this.is_load){
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.company('get_vip_order', {page: this.page,uid:this.user.uid});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
        this.ebook_num = res.ebook_num;
      }
    },
    pop:function (){
      this.get_data();
      this.is_pop = true;
    },
    get_data: async function (){
      this.$_showLoading();
      let res = await this.$_api.setting('config',{type:'recharge'});
      this.$_hideLoading();
      if(res.errcode == 0 && res.data.content){
        this.class_list = res.data.content.class;
      }
    },
    topay:async function (type,item){
      let that = this;
      this.$_showLoading();
      let res = await this.$_api.company('vip_pay', {
        uid:that.user.uid,vip_type:type,recharge:item
      });
      this.$_hideLoading();
      // this.$_showToast(res.errmsg,res.style);
      if(res.errcode == 0){
        console.log(res);
        this.is_pay = true;
        this.pay_no = res.pay_no;
        this.pay_code = res.url;
        clearInterval(this.timer);
        this.timer = setInterval(async function (){
          let check = await that.$_api.company('vip_check_pay', {pay_no : res.pay_no});
          if (check.errcode == 0) {
            clearInterval(that.timer);
            that.$_showToast(check.errmsg);
            that.$_vueVuex('user',check.user);
            that.$router.go(0);
          }
        },2000)
      }else{
        this.$_showToast(res.errmsg,res.style);
      }
    },
    del:async function (id){
      let that = this;
      that.$_showLoading();
      let res = await that.$_api.company('vip_order_del', {id:id});
      that.$_hideLoading();
      if (res.errcode == 0) {
        that.$_showToast(res.errmsg);
        that.get_list();
      }
    },
    pay_close:function (){
      this.is_pay = false;
    },
  }
}
</script>

<style scoped>
.item{
  display:flex;
  border-radius: 10px;
  box-shadow: 0 0 5px #ccc;
  margin: 30px;
  padding: 30px 0;
  justify-content: center;
  align-items: center;
}
.bg{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  align-items: center;
  justify-content: center;
  justify-items: center;
}
.bg .box{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: #fff;
  text-align: center;
  font-size: 18px;
}
.bg span{
  position: absolute;
  left: 50%;
  bottom: -100px;
  font-size: 40px;
  margin-left: -20px;
  color: #555;
  cursor: pointer;
}
</style>